import { getOSM } from '../OverworldAnimation.js';
import OverworldAction from './OverworldAction.js';
import { gameSaveManager } from './GameSaveManager.js';

import { KPI_A, KPI_S, KPI_D, KPI_W, KPI_L, KPI_K, KPI___, KPI_ENTER } from '../OverworldAnimation.js';
import BattleAction from '../state-machine/battle-actions/BattleAction.js';
import ActionType from '../state-machine/battle-actions/ActionType.js';
import { LOAD_GAME, CANT_SELL_THIS_ITEM, IDLE } from '../constants.js';
export default class MenuHandler {
    constructor() {}

    handlePlayerGenderMenu() {
        const osm = getOSM();
        const playerGenderMenu = osm.playerGenderMenu;

        osm.actions.push(
            new OverworldAction({
                startAction: () => {
                    playerGenderMenu.isActive = true;
                },
                action: () => {
                    if (KPI_W) {
                        playerGenderMenu.decreaseVerticalOption();
                    }
                    if (KPI_S) {
                        playerGenderMenu.increaseVerticalOption();
                    }
                    if (KPI_L) {
                        osm.player.gender = playerGenderMenu.getCurrentOptionValue().toLowerCase();
                        return true;
                    }
                    return false;
                },
                endAction: () => {
                    playerGenderMenu.isActive = false;
                },
            })
        );
    }

    handleSaveFileMenu() {
        const osm = getOSM();
        const saveFileMenu = osm.saveFileMenu;

        osm.undarkenScreen(0.05);
        osm.actions.push(
            new OverworldAction({
                action: () => {
                    if (KPI_W) {
                        saveFileMenu.decreaseVerticalOption();
                    }
                    if (KPI_S) {
                        saveFileMenu.increaseVerticalOption();
                    }
                    if (KPI_L) {
                        gameSaveManager.slot = saveFileMenu.currentOption;
                        return true;
                    }
                    return false;
                },
            })
        );
        osm.actions.push(
            new OverworldAction({
                startAction: () => {
                    saveFileMenu.saveFileDetailMenu.isActive = true;
                    saveFileMenu.saveFileDetailMenu.currentOption = 0;
                },
                action: () => {
                    if (saveFileMenu.currentOptionIsNew()) {
                        osm.stateQueue.push(LOAD_GAME);
                        return true;
                    }
                    saveFileMenu.saveFileDetailMenu.handleVerticalInput();
                    if (KPI_K) {
                        saveFileMenu.saveFileDetailMenu.shouldCancel = true;
                        return true;
                    }
                    if (KPI_L) {
                        return true;
                    }
                    return false;
                },
                endAction: () => {
                    saveFileMenu.saveFileDetailMenu.isActive = false;
                },
            })
        );
        osm.script(() => {
            if (saveFileMenu.saveFileDetailMenu.shouldCancel) {
                saveFileMenu.saveFileDetailMenu.shouldCancel = false;
                osm.stateQueue.push(osm.currentState);
                return true;
            }
            if (saveFileMenu.currentOptionIsNew()) {
                osm.darkenScreen(0.05);
                return true;
            }
            switch (saveFileMenu.saveFileDetailMenu.getCurrentOptionValue()) {
                case 'Load':
                    osm.darkenScreen(0.05);
                    osm.stateQueue.push(LOAD_GAME);
                    osm.stateQueue.push(IDLE);
                    break;
                case 'Cancel':
                    osm.stateQueue.push(osm.currentState);
                    break;
                case 'Delete':
                    osm.readText('Delete this save file?');
                    this.handleYesOrNoMenu({ defaultOption: 1 });
                    osm.clearText();
                    osm.script(() => {
                        if (osm.yesOrNoMenu.yes()) {
                            osm.darkenScreen(0.05);
                            osm.script(() => {
                                saveFileMenu.deleteOption();
                                saveFileMenu.update();
                            });
                            osm.undarkenScreen(0.05);
                        }
                        osm.stateQueue.push(osm.currentState);
                    });
                    break;
            }
        });
    }

    handleYesOrNoMenu({ defaultOption = 0, position }) {
        const osm = getOSM();
        const yesOrNoMenu = osm.yesOrNoMenu;
        yesOrNoMenu.position = position;
        osm.actions.push(
            new OverworldAction({
                startAction: () => {
                    yesOrNoMenu.isActive = true;
                    yesOrNoMenu.currentOption = defaultOption;
                },
                action: () => {
                    osm.cursor = osm.overworldText.length;
                    yesOrNoMenu.handleVerticalInput();
                    if (KPI_K) {
                        yesOrNoMenu.shouldCancel = true;
                        return true;
                    }
                    if (KPI_L) {
                        return true;
                    }
                    return false;
                },
                endAction: () => {
                    yesOrNoMenu.isActive = false;
                    yesOrNoMenu.position = null;
                },
            })
        );
    }

    handleKeyboardMenu({
        targetDisplayText = '',
        targetType = 'player',
        defaultText = '',
        cancelOnEmpty = false,
    }) {
        const osm = getOSM();
        const keyboardMenu = osm.keyboardMenu;

        osm.undarkenScreen(0.05);
        osm.actions.push(
            new OverworldAction({
                startAction: () => {
                    keyboardMenu.targetDisplayText = targetDisplayText;
                    keyboardMenu.targetType = targetType;
                    keyboardMenu.output = defaultText;
                },
                action: () => {
                    if (KPI_W) {
                        keyboardMenu.decreaseVerticalOption();
                    }
                    if (KPI_S) {
                        keyboardMenu.increaseVerticalOption();
                    }
                    if (KPI_A) {
                        keyboardMenu.decreaseHorizontalOption();
                    }
                    if (KPI_D) {
                        keyboardMenu.increaseHorizontalOption();
                    }
                    if (KPI_L) {
                        keyboardMenu.selectCurrentChar();
                    }
                    if (KPI_K) {
                        keyboardMenu.deleteLastChar();
                    }
                    if (KPI_ENTER) {
                        keyboardMenu.uppercase = !keyboardMenu.uppercase;
                    }
                    if (KPI___) {
                        if (osm.stateQueue.length === 0) {
                            console.warn('Next state was not specified. Falling back to previous state.');
                            osm.stateQueue.push(osm.previousState);
                        }
                        if (!cancelOnEmpty) {
                            return keyboardMenu.output.trim() !== '';
                        }
                        return true;
                    }
                    return false;
                },
                endAction: () => {
                    if (osm.shouldCancel) {
                        osm.shouldCancel = false;
                        return true;
                    }
                    if (keyboardMenu.output === '') {
                        return true;
                    }
                },
            })
        );
        osm.darkenScreen(0.05);
    }

    handlePokemonMenu() {
        // TODO: Implement
    }

    handleBagMenuBattle(stateMachine) {
        const d = stateMachine.battleGUI.drawables;
        const bagMenu = stateMachine.bagMenu;
        stateMachine.actions.push(
            new BattleAction({
                type: ActionType.INPUT,
                description: 'User can navigate through bag menu.',
                startAction: () => {
                    bagMenu.update();
                    d.bagMenu.visible = true;
                    d.pokemonMenu.visible = false;
                    stateMachine.battleGUI.text.visible = false;
                },
                action: () => {
                    if (stateMachine.awaitCancelInput()) {
                        stateMachine.shouldCancel = true;
                        return true;
                    }
                    return bagMenu.manageInputs();
                },
                endAction: () => {
                    if (stateMachine.shouldCancel) {
                        d.bagMenu.visible = false;
                        stateMachine.selectedItem = null;
                        stateMachine.battleGUI.text.visible = true;
                        return;
                    }
                },
            })
        );
    }

    handleBagMenuOverworld(stateMachine) {
        const bagMenu = stateMachine.bagMenu;
        bagMenu.update();
        stateMachine.actions.push(
            new OverworldAction({
                startAction: () => {
                    bagMenu.update();
                },
                action: () => {
                    if (stateMachine.awaitCancelInput()) {
                        stateMachine.shouldCancel = true;
                        return true;
                    }
                    return bagMenu.manageInputs();
                },
                endAction: () => {
                    if (stateMachine.shouldCancel) {
                        return;
                    }
                    stateMachine.selectedItem = bagMenu.createItemFromCurrentOption();
                },
            })
        );
        return;
    }

    handleBagMenuSell(stateMachine) {
        const bagMenu = stateMachine.bagMenu;
        bagMenu.update();
        stateMachine.actions.push(
            new OverworldAction({
                startAction: () => {
                    bagMenu.update();
                    stateMachine.overworldText = '';
                },
                action: () => {
                    if (stateMachine.awaitCancelInput()) {
                        stateMachine.shouldCancel = true;
                        return true;
                    }
                    return bagMenu.manageInputs();
                },
                endAction: () => {
                    if (stateMachine.shouldCancel) {
                        return;
                    }
                    stateMachine.selectedItem = bagMenu.createItemFromCurrentOption();
                    if (
                        stateMachine.selectedItem.price === null ||
                        stateMachine.selectedItem.price === undefined
                    ) {
                        stateMachine.stateQueue.push(CANT_SELL_THIS_ITEM);
                    }
                },
            })
        );
        return;
    }
}
